"use client";

import { ErrorBoundary } from "@soprisapps/components/components/utilities/rollbar/ErrorBoundary";
import { SchoolFeedContent } from "@soprisapps/components/components/schoolfeed/SchoolFeedDisplay";
import styles from "@soprisapps/components/pages/styles/SchoolFeedFullPage.module.scss";
import SchoolFeedSearchFilters, {
  useSchoolFeedData,
} from "@soprisapps/components/components/header/schoolfeed/SchoolFeedSearchFilter";
import classNames from "classnames";
import schoolFeedDisplayStyles from "@soprisapps/components/components/schoolfeed/styles/SchoolFeedDisplay.module.scss";

const SchoolFeedFullPage = () => {
  const { contentCounts, urlQuery } = useSchoolFeedData();

  const displayContainerClassName = classNames({
    [schoolFeedDisplayStyles.displayContainer]: true,
    [schoolFeedDisplayStyles.displayContainerFiles]: urlQuery.type === "files",
  });

  return (
    <ErrorBoundary>
      <main id={"sb-main-content"}>
        <SchoolFeedSearchFilters
          className={styles.searchFilters}
          contentCounts={contentCounts}
        />
        <div
          className={displayContainerClassName}
          data-current-view={urlQuery.currentView}
        >
          <SchoolFeedContent urlQuery={urlQuery} />
        </div>
      </main>
    </ErrorBoundary>
  );
};

export default SchoolFeedFullPage;
